"use client";

// packages/eden-headings/src/components/H2.jsx
import styled from "styled-components";
import { mediaBreak600w } from "@churchofjesuschrist/eden-styled-helpers";
import { jsx } from "react/jsx-runtime";
var H2Styled = styled.h2`
  margin: 0;
  font: normal normal 300 calc(28rem / 16) / 1.2 var(--unity-font-family-sans);

  ${(props) => props.$small ? "" : mediaBreak600w`font-size: calc(32rem / 16);`};
`;
var H2 = ({ small, children, renderAs, ...props }) => /* @__PURE__ */ jsx(H2Styled, { $small: small, as: renderAs, ...props, children });
H2.displayName = "H2";
var H2_default = H2;
export {
  H2_default as default
};
